import { makeApiRequest } from './apiBody';

async function fetchIntermediarySummary() {
  try {
    const response = await makeApiRequest({
      serviceName: 'intermediary',
      resourceName: 'intermediary',
      actionName: 'intermediaryPolicyStats',
      data : {},
    });
    
    return response;
  } catch (err) {
    throw err; // Let the caller handle the error
  }
}


async function fetchClientsByIntermediary(ref) {
  try {
    const response = await makeApiRequest({
      serviceName: 'underwriting',
      resourceName: 'policy',
      actionName: 'getClientsByIntermediary',
      data: {}
    });
    
    return response;
  } catch (err) {
    throw err; // Let the caller handle the error
  }
}


export { 
    fetchIntermediarySummary,
    fetchClientsByIntermediary,
};